import { useCallback, useEffect, useState } from 'react'
// import * as Sentry from '@sentry/react'
import { Button, Card, Col, Flex, Row, Typography } from 'antd'
// import ym from 'react-yandex-metrika'
import { USER_API, MEDIATEKA_DOWNLOAD } from '@/constants/urls'
import { IMessageAboutComplete } from '@/models'
import { useHttp } from '@/hooks/useHttp'
import { useAppSelector } from '@/hooks/useReduxHooks'
import { RichTextPreview, PreloaderSmall } from '@/components/ui'
import { useGetMessageAboutComplete } from '@/api/quiz/useProgress'

interface IQuizCompletedProps {
  image: string
  text?: string
  richText?: string
  survey?: { quiz_id: string; uuid: string; is_fast?: boolean; is_rzd_test?: boolean }
  setSurvey?: (e: string) => void
  isWrongSurvey: boolean
}

const QuizCompleted = ({
  image,
  richText,
  text = 'Благодарим за прохождение опроса!',
  survey,
  isWrongSurvey
}: IQuizCompletedProps) => {
  const [drugoeDeloResult, setDrugoeDeloResult] = useState<{ type: number; message: string } | null>()
  const token = useAppSelector((state) => state.auth.accessToken)
  const { request } = useHttp()
  const user = useAppSelector((state) => state.user.data)
  const { messageAboutComplete } = useGetMessageAboutComplete(survey?.uuid)

  const getCompleteTask = useCallback(async () => {
    try {
      await request<IMessageAboutComplete>(`${USER_API}/user/drugoedelo/complete-task/${survey?.uuid}`, 'GET', null, {
        Authorization: `Bearer ${token}`
      })
      setDrugoeDeloResult({ type: 1, message: 'Вам начислены баллы на платформе Другое Дело' })
    } catch (e) {
      // Sentry.captureException(e)
      // Sentry.captureMessage('QuizCompleted completeTask USER_API/user/drugoedelo/complete-task/survey?.uuid GET')
      if (e?.data?.code === 403) {
        setDrugoeDeloResult({
          type: 2,
          message: 'Вам доступны баллы на платформе Другое Дело. Чтобы их получить, необходима авторизация Вконтакте'
        })
      }

      if (e?.data?.code === 500) setDrugoeDeloResult(null)
    }
  }, [request, survey?.uuid, token])

  useEffect(() => {
    if (survey?.uuid) {
      if (drugoeDeloResult === undefined) getCompleteTask()
      // if (drugoeDeloResult?.type === 2) {
      //   setUserDepartment(user?.department.uuid)
      //   setUserPosition(user?.position.uuid)
      // }
    }
  }, [getCompleteTask, drugoeDeloResult, user, survey?.uuid])

  if (!survey && !isWrongSurvey) return null

  return (
    <Flex vertical gap={16}>
      {!survey?.is_fast && !survey?.is_rzd_test && (
        <>
          <Card styles={{ body: { padding: 14, textAlign: 'center', fontSize: '18px', fontWeight: 700 } }}>
            {isWrongSurvey
              ? 'Этот опрос не найден!'
              : 'Благодарим за Ваши ответы и уделённое время. Желаем хорошего дня!'}
          </Card>
        </>
      )}

      {!isWrongSurvey && (
        <Card>
          <Row gutter={20} wrap justify='center' align='middle'>
            <Col md={7} xs={24} style={{ textAlign: 'center' }}>
              <img
                src={
                  messageAboutComplete?.file?.file_name
                    ? `${MEDIATEKA_DOWNLOAD}/${messageAboutComplete.file.file_name}`
                    : image
                }
                alt='Иконка завершения опроса'
                style={{ width: '252px', height: 'fitContent' }}
              />
            </Col>
            <Col md={16} xs={24} style={{ textAlign: 'center' }}>
              <Flex vertical justify='space-around' align='center'>
                {messageAboutComplete || !survey?.uuid ? (
                  (!messageAboutComplete || messageAboutComplete?.text === '') && !richText ? (
                    <Typography.Text style={{ fontSize: '22px' }}>{text}</Typography.Text>
                  ) : (
                    <RichTextPreview content={richText ?? messageAboutComplete?.text} />
                  )
                ) : (
                  <PreloaderSmall size='md' />
                )}
                {/* {!!drugoeDeloResult && (
                  <>
                    <Text size='xl' className='offset-top-15'>
                      {drugoeDeloResult.message}
                    </Text>
                    {drugoeDeloResult.type === 2 && (
                      <div className='offset-top-10' style={{ maxWidth: 350, width: '100%' }} ref={vkRef} />
                    )}
                  </>
                )} */}
                <Button
                  type='primary'
                  style={{ marginTop: 15 }}
                  onClick={() => (window.location.href = 'nchstage://app')}
                >
                  Закрыть
                </Button>
              </Flex>
            </Col>
          </Row>
        </Card>
      )}
    </Flex>
  )
}

export default QuizCompleted
